import type { IList } from '@dakedake/types'
import { listDeatil } from '@/services'
import { useCallback, useState } from 'react'

export default function useListDetail() {
  const [categoryDetail, setCategoryDetail] = useState<IList>()

  const getCategoryDetail = useCallback(async (id: string) => {
    const res = await listDeatil({ id })
    setCategoryDetail(res.data)
  }, [])

  return {
    categoryDetail,
    getCategoryDetail
  }
}
